import type { AppUser } from '@tracedocuments/types';

/** Set after login; consumed once by AppDataProvider to avoid auth/me race on admin shell. */
export const AUTH_ME_BOOTSTRAP_KEY = 'td-auth-me-bootstrap';

export function setAuthMeBootstrap(user: AppUser): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(AUTH_ME_BOOTSTRAP_KEY, JSON.stringify(user));
}

export function consumeAuthMeBootstrap(): AppUser | undefined {
  if (typeof window === 'undefined') return undefined;
  const raw = sessionStorage.getItem(AUTH_ME_BOOTSTRAP_KEY);
  if (!raw) return undefined;
  sessionStorage.removeItem(AUTH_ME_BOOTSTRAP_KEY);
  try {
    return JSON.parse(raw) as AppUser;
  } catch {
    return undefined;
  }
}
